import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@mui/material';

import { useSpecification } from '@/shared/hooks/useSpecification';
import { DorimPromoPaths, RouterLink, useMatchLinks } from '@/shared/lib/react-router';

import { useSpecificationIdFromPathParams } from '../../../../../lib';

export const ToolbarTabs = () => {
  const specificationId = useSpecificationIdFromPathParams();
  const stringifiedSpecificationId = String(specificationId);
  const { t } = useTranslation('specifications-detail-page');

  const { data } = useSpecification({ specificationId });
  const { has_display_tasks, has_purchase_drugs, has_sale_drugs } = data?.agreement ?? {};

  const procurementPlanPath = DorimPromoPaths.generateSpecificationDetailProcurementPlanPath({
    specificationId: stringifiedSpecificationId,
  });
  const planogramPath = DorimPromoPaths.generateSpecificationDetailPlanogramPath({
    specificationId: stringifiedSpecificationId,
  });
  const salesPlanPath = DorimPromoPaths.generateSpecificationDetailSalesPlanPath({
    specificationId: stringifiedSpecificationId,
  });

  const [matchedLink] = useMatchLinks(procurementPlanPath, planogramPath, salesPlanPath);

  if (!specificationId || !matchedLink?.pathname || !(has_display_tasks || has_purchase_drugs || has_sale_drugs)) {
    return null;
  }

  return (
    <Tabs value={matchedLink.pathname} sx={{ pl: 1 }} textColor="primary" indicatorColor="primary">
      {has_purchase_drugs && (
        <Tab
          component={RouterLink}
          to={procurementPlanPath}
          value={procurementPlanPath}
          replace
          label={t('document-toolbar.toolbar-tabs.procurement-plan')}
        />
      )}
      {has_display_tasks && (
        <Tab
          component={RouterLink}
          to={planogramPath}
          value={planogramPath}
          replace
          label={t('document-toolbar.toolbar-tabs.planogram')}
        />
      )}
      {has_sale_drugs && (
        <Tab
          component={RouterLink}
          to={salesPlanPath}
          value={salesPlanPath}
          replace
          label={t('document-toolbar.toolbar-tabs.sales-plan')}
        />
      )}
    </Tabs>
  );
};
